export function openLinkInExternalWindow(url) {
  const params = {
    height: 530,
    width: 430,
  }

  params.left = window.screenX + window.outerWidth / 2 - params.width / 2
  params.top = window.screenY + window.outerHeight / 2 - params.height / 2

  return window.open(url, 'ExternalWindowButton', serialize(params))
}

function serialize(params) {
  const results = []
  for (const [key, value] of Object.entries(params)) {
    results.push(`${key}=${value}`)
  }
  return results.join(',')
}
